import React from 'react';
import PropTypes from 'prop-types';
import Blanket from './Blanket';
import Menu from './Menu';

const Dropdown = ({ children, isOpen, target, onClose }) => (
  <div className="sm:max-w-315" css={{ position: 'inherit' }}>
    {target}
    {isOpen ? <Menu>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);

Dropdown.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  target: PropTypes.object,
};

export default Dropdown;
